import { cn } from "@/lib/utils";
import { focusRing } from "@/components/Onboarding/ui/buttons";

interface TagProps {
  selected: boolean;
  onSelect: () => void;
  children: string;
  disabled?: boolean;
}

/** Pill option of a single-choice tag row (role radio inside a `radiogroup`). */
export function Tag({ selected, onSelect, children, disabled = false }: TagProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      disabled={disabled}
      onClick={onSelect}
      className={cn(
        "inline-flex h-10 items-center rounded-g-pill border px-4 text-[14px] font-semibold transition-colors duration-150 ease-out",
        selected
          ? "border-g-primary bg-g-primary-tint text-g-primary-press"
          : "border-g-line-strong bg-g-bg-card text-g-ink-700 hover:border-g-primary-muted hover:bg-g-primary-subtle active:bg-g-primary-wash",
        "disabled:cursor-not-allowed disabled:opacity-60",
        focusRing,
      )}
    >
      {children}
    </button>
  );
}
